/* ============================================================================
 * Movatic WMS — Frontend | CesarFilho 932048016
 * Arquivo: src/components/ui/label.tsx
 * ========================================================================== */
import * as React from "react";

export const Label = ({ className = "", ...props }: React.LabelHTMLAttributes<HTMLLabelElement>) => (
    <label className={`block text-xs uppercase tracking-wide text-slate-300 mb-1 ${className}`} {...props} />
);
export default Label;
